import { User } from '@/app-modules/store/modules/user';
import { ChatStatusUserMap } from '@/app-modules/store/modules/chat-status-user-map';

enum UserChatStatus {
  StandardUser = 34000003,
  ChatModerator = 28931832,
  TeamLeader = 18591103,
  ShiftLeader = 16547191
}

function MapUserChatStatus(input: UserChatStatus|string): string|UserChatStatus {
  const chatStatuses = new Map<UserChatStatus, string[]> ([
                                                  [UserChatStatus.StandardUser, ['STANDARDUSER']],
                                                  [UserChatStatus.ChatModerator, ['CHATMODERATOR', 'CM']],
                                                  [UserChatStatus.TeamLeader, ['TEAMLEADER', 'TL']],
                                                  [UserChatStatus.ShiftLeader, ['SHIFTLEADER', 'SL']]
                                                ]);

  if (typeof input === 'string') {
    for (const [chatStatus, chatStatusAliases] of chatStatuses.entries()){
      if (chatStatusAliases.indexOf(input.toUpperCase()) > -1) {
        return chatStatus;
      }
    }
  } else {
    return chatStatuses.get(input as UserChatStatus)[0];
  }
  return null;
}

interface IUserChatStatusService {
  getChatStatusForUser(username: string): Promise<UserChatStatus>;
  getCMPrefix(): Promise<string>;
  getUserCsStatus(username: string): Promise<boolean>;
  getInvalidWordsForPassword(): Promise<string[]>;
  fetchUserRolesFromServer(cmUser: User): Promise<ChatStatusUserMap>;
}

export { IUserChatStatusService, UserChatStatus, MapUserChatStatus };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/user-chat-status-service/user-chat-status-service-interface.ts